import fetchApiWithAuth from "./fetch";

export type ProductQuestionAnswer = {
  text: string;
  created_at: string;
  generated: boolean;
  approved_at: string | null;
  sent_at: string | null;
  error: string | null;
};

export type ProductQuestionItem = {
  id: number;
  external_id: string;
  marketplace_auth_id: number;
  marketplace: string;
  integration_login: string;
  asked_at: string;
  question_text: string;
  nm_id?: string | null;
  sku?: string | null;
  article?: string | null;
  product_name?: string | null;
  marketplace_answered: boolean;
  workflow_status: string;
  answer: ProductQuestionAnswer | null;
  is_processed: boolean;
};

export type ProductQuestionsListResponse = {
  data: ProductQuestionItem[];
  total: number;
  total_page: number;
  hasMore: boolean;
};

export const getProductQuestions = async (props: {
  marketplace?: string[];
  marketplace_auth_id?: number[];
  processed?: "processed" | "unprocessed" | "all";
  search?: string;
  article?: string;
  sorting?: "asked_at_desc" | "asked_at_asc";
  page?: number;
}) => {
  const result = await fetchApiWithAuth("/api/product-questions", {
    method: "POST",
    body: JSON.stringify(props),
  });
  return (await result.json()) as ProductQuestionsListResponse;
};

export const updateProductQuestion = async (props: {
  id: number;
  answer?: { text: string };
  workflow_status?: string;
}) => {
  const result = await fetchApiWithAuth(`/api/product-questions/${props.id}`, {
    method: "PATCH",
    body: JSON.stringify({
      answer: props.answer,
      workflow_status: props.workflow_status,
    }),
  });
  return (await result.json()) as ProductQuestionItem;
};

export const getProductQuestionsFilterOptions = async () => {
  const result = await fetchApiWithAuth("/api/product-questions/filter_options");
  return (await result.json()) as {
    integrations: {
      id: number;
      login: string;
      marketplace: string;
      label: string;
    }[];
    marketplaces: string[];
  };
};
